const PortFlioAtRiskTypes = {
	/** ***************GET PORTFOLIO AT RISK START ************* */
	PORTFLIO_AT_RISK_START: 'PORTFLIO_AT_RISK_START',
	PORTFLIO_AT_RISK_SUCCESS: 'PORTFLIO_AT_RISK_SUCCESS',
	PORTFLIO_AT_RISK_FAILURE: 'PORTFLIO_AT_RISK_FAILURE',
	PORTFLIO_AT_RISK_RESPONSE_RESET: 'PORTFLIO_AT_RISK_RESPONSE_RESET',
	PORTFLIO_AT_RISK_RESPONSE_CHANGED: 'PORTFLIO_AT_RISK_RESPONSE_CHANGED',
	/** ***************GET PORTFOLIO AT RISK END ************* */

	/** *********************LOAN_INFO_BASEDON_MEMBER START ******** */
	GET_LOAN_INFO_BASEDON_MEMBER_START: 'GET_LOAN_INFO_BASEDON_MEMBER_START',
	GET_LOAN_INFO_BASEDON_MEMBER_SUCCESS: 'GET_LOAN_INFO_BASEDON_MEMBER_SUCCESS',
	GET_LOAN_INFO_BASEDON_MEMBER_FAILURE: 'GET_LOAN_INFO_BASEDON_MEMBER_FAILURE',
	GET_LOAN_INFO_BASEDON_MEMBER_RESPONSE_RESET: 'GET_LOAN_INFO_BASEDON_MEMBER_RESPONSE_RESET',
	GET_LOAN_INFO_BASEDON_MEMBER_RESPONSE_CHANGED: 'GET_LOAN_INFO_BASEDON_MEMBER_RESPONSE_CHANGED',
	/** *********************LOAN_INFO_BASEDON_MEMBER EMD ******** */
};

export default PortFlioAtRiskTypes;
